import { render, staticRenderFns } from "./salary_resign_1.vue?vue&type=template&id=9fe8fad4&scoped=true"
import script from "./salary_resign_1.vue?vue&type=script&lang=ts"
export * from "./salary_resign_1.vue?vue&type=script&lang=ts"
import style0 from "./salary_resign_1.vue?vue&type=style&index=0&id=9fe8fad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe8fad4",
  null
  
)

export default component.exports